import { Chip, MenuItem, TextField, Typography } from '@mui/material';
import { Circle, Square } from '@phosphor-icons/react';
import { INode } from '../../Context/FormBuilderContext';

interface ListWidgetProps {
  node: INode;
}

export function ListWidget({ node }: ListWidgetProps) {
  const styles = node?.data?.styles;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '8px',
      }}
    >
      {node?.data?.requiredField && (
        <Chip
          label="Required"
          size="small"
          style={{ width: 'fit-content', marginBottom: '4px' }}
        />
      )}

      {node?.data?.title && (
        <Typography
          style={{
            fontWeight: styles?.title?.isBold ? '700' : '400',
            fontStyle: styles?.title?.isItalic ? 'italic' : 'normal',
            textDecoration: styles?.title?.isUnderlined ? 'underline' : 'none',
            textAlign: styles?.title?.textAlign || 'left',
            fontFamily: styles?.title?.fontFamily || 'Roboto, sans-serif',
            fontSize: `${styles?.title?.fontSize || 16}px`,
            color: styles?.title?.color || '#1F2937',
            width: '100%',
            letterSpacing: '0.5px',
          }}
        >
          {node?.data?.title}
        </Typography>
      )}

      {node?.data?.question && (
        <Typography
          style={{
            fontWeight: styles?.question?.isBold ? '600' : '400',
            fontStyle: styles?.question?.isItalic ? 'italic' : 'normal',
            textDecoration: styles?.question?.isUnderlined
              ? 'underline'
              : 'none',
            textAlign: styles?.question?.textAlign || 'left',
            fontFamily: styles?.question?.fontFamily || 'Roboto, sans-serif',
            fontSize: `${(styles?.question?.fontSize || 16) * 0.875}px`,
            color: styles?.question?.color || '#475467',
            width: '100%',
            letterSpacing: '0.5px',
          }}
        >
          {node?.data?.question}
        </Typography>
      )}

      {node?.data?.typeQuestion === 'dropdown' &&
        node?.data?.listItems &&
        node?.data?.listItems?.length > 0 && (
          <TextField
            select
            sx={{
              '& .MuiInputBase-root': {
                height: '32px',
                borderRadius: '4px',
                border: '1px solid #EAECF0',
                backgroundColor: '#F9FAFB',
                color: '#475467',
                margin: '0px',
              },
            }}
            variant="outlined"
            fullWidth
            size="small"
          >
            {node?.data?.listItems?.map((item, index) => (
              <MenuItem key={index} value={item.description}>
                {item.description}
              </MenuItem>
            ))}
          </TextField>
        )}

      {node?.data?.typeQuestion !== 'dropdown' &&
        node?.data?.listItems &&
        node?.data?.listItems?.length > 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '8px',
            }}
          >
            {node?.data?.listItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '4px 0px',
                  borderRadius: '4px',
                  height: '100%',
                  gap: '8px',
                }}
              >
                {node?.data?.typeQuestion === 'single' && (
                  <Circle size={20} color="#475467" />
                )}
                {node?.data?.typeQuestion === 'multiple' && (
                  <Square size={20} color="#475467" />
                )}
                <Typography
                  variant="body2"
                  style={{
                    fontSize: '14px',
                    color: '#475467',
                  }}
                >
                  {item.description || `Item ${index + 1}`}
                </Typography>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
